import React from "react";
import { size, sumBy } from "lodash";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { AiccFeedbackDownvoteTurn } from "types/model/aiccCustomer";
import ChartCard from "./ChartCard";
import TooltipBox from "./TooltipBox";
import {
  AXIS_STROKE,
  AXIS_TICK,
  BAR_MAX_SIZE,
  BAR_RADIUS,
  CHART_COLORS,
  CHART_HEIGHT,
  CHART_MARGIN,
  GRID_STROKE,
  HOVER_CURSOR_FILL,
} from "./chartTheme";

interface Props {
  data: AiccFeedbackDownvoteTurn[];
  isLoading?: boolean;
}

function DownvoteTurnChart({ data, isLoading }: Props) {
  return (
    <ChartCard
      title="Avg. Turns to Downvote"
      description="Distribution: at which round did the user press thumbs-down"
      isLoading={isLoading}
      hasData={size(data) > 0 && sumBy(data, "thumbsDown") > 0}
    >
      <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
        <BarChart data={data} margin={CHART_MARGIN}>
          <CartesianGrid vertical={false} stroke={GRID_STROKE} />
          <XAxis
            dataKey="label"
            tick={AXIS_TICK}
            tickLine={false}
            axisLine={{ stroke: AXIS_STROKE }}
            height={44}
            label={{ value: "Round", position: "insideBottomRight", offset: 0, fill: AXIS_TICK.fill, fontSize: 12 }}
          />
          <YAxis allowDecimals={false} tick={AXIS_TICK} tickLine={false} axisLine={false} width={48} />
          <Tooltip
            cursor={{ fill: HOVER_CURSOR_FILL }}
            content={({ active, payload }) => {
              const point = payload?.[0]?.payload as AiccFeedbackDownvoteTurn | undefined;
              if (!active || !point) {
                return null;
              }

              return (
                <TooltipBox
                  title={point.label === "10+" ? "Round 10 and later" : `Round ${point.label}`}
                  rows={[{ label: "👎 Thumbs Down", value: String(point.thumbsDown), color: CHART_COLORS.neutral }]}
                />
              );
            }}
          />
          <Bar dataKey="thumbsDown" fill={CHART_COLORS.neutral} maxBarSize={BAR_MAX_SIZE} radius={BAR_RADIUS} />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default DownvoteTurnChart;
